export const EXPORT_ROBOT_PREFIX = 'EXPORT_ROBOT';
export const EXPORT_ROBOT_REQUEST = `${EXPORT_ROBOT_PREFIX}_REQUEST`;
export const EXPORT_ROBOT_SUCCESS = `${EXPORT_ROBOT_PREFIX}_SUCCESS`;
export const EXPORT_ROBOT_ERROR = `${EXPORT_ROBOT_PREFIX}_ERROR`;
export const EXPORT_ROBOT_ERROR_MESSAGE = 'Unable to export robot, please try again.';

export const exportRobotRequest = () => ({
  type: EXPORT_ROBOT_REQUEST,
});